module.exports = __webpack_public_path__ + "img/namer_no.9f561ad3.png";